// extracted by css-extract-rspack-plugin
export default {"WizardHeader":"opportunity-common_WizardHeader__GE411","Form":"opportunity-common_Form__6Sy2q"};